import React from 'react';

export const OpsEventContext = React.createContext({
  opsEvent: undefined,
  eventType: undefined,
  setState: undefined,
  consents: undefined,
  initialConsents: undefined,
});
